/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../graphql/types';

import { ExecutionResult } from 'graphql';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UpdateCustomerProfileMutationVariables = Types.Exact<{
  input: Types.UpdateCustomerInput;
}>;

export type UpdateCustomerProfileMutation = {
  readonly __typename?: 'Mutation';
  readonly updateCustomer: {
    readonly __typename?: 'UpdateCustomerResponse';
    readonly customer: {
      readonly __typename: 'Customer';
      readonly id: string;
      readonly firstName: string | null;
      readonly lastName: string | null;
      readonly email: string | null;
      readonly phoneNumber: string | null;
      readonly birthday: string | null;
    };
  } | null;
};

export type CustomerProfileFieldsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type CustomerProfileFieldsQuery = {
  readonly __typename?: 'Query';
  readonly currentCustomer: {
    readonly __typename: 'Customer';
    readonly id: string;
    readonly firstName: string | null;
    readonly lastName: string | null;
    readonly email: string | null;
    readonly phoneNumber: string | null;
    readonly birthday: string | null;
  } | null;
};

export const updateCustomerProfileMutationMock: ExecutionResult<UpdateCustomerProfileMutation> =
  {
    data: {
      updateCustomer: {
        customer: {
          id: 'e509e6ea-9fee-442a-9962-587ce7190430',
          firstName: 'Hello World',
          lastName: 'Hello World',
          email: 'Hello World',
          phoneNumber: 'Hello World',
          birthday: 'Hello World',
          __typename: 'Customer',
        },
      },
    },
  };

export const customerProfileFieldsQueryMock: ExecutionResult<CustomerProfileFieldsQuery> =
  {
    data: {
      currentCustomer: {
        id: '8da7a716-3ba7-4eda-96e8-a185e3da00a9',
        firstName: 'Hello World',
        lastName: 'Hello World',
        email: 'Hello World',
        phoneNumber: 'Hello World',
        birthday: 'Hello World',
        __typename: 'Customer',
      },
    },
  };

export const UpdateCustomerProfileDocument = gql`
  mutation UpdateCustomerProfile($input: UpdateCustomerInput!) {
    updateCustomer(input: $input) {
      customer {
        id
        firstName
        lastName
        email
        phoneNumber
        birthday
        __typename
      }
    }
  }
`;

export function useUpdateCustomerProfileMutation() {
  return Urql.useMutation<
    UpdateCustomerProfileMutation,
    UpdateCustomerProfileMutationVariables
  >(UpdateCustomerProfileDocument);
}
export const CustomerProfileFieldsDocument = gql`
  query CustomerProfileFields {
    currentCustomer {
      id
      firstName
      lastName
      email
      phoneNumber
      birthday
      __typename
    }
  }
`;

export function useCustomerProfileFieldsQuery(
  options?: Omit<
    Urql.UseQueryArgs<CustomerProfileFieldsQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    CustomerProfileFieldsQuery,
    CustomerProfileFieldsQueryVariables
  >({ query: CustomerProfileFieldsDocument, ...options });
}
